<template>
  <div class="functions-dict" ref="container">
    <div class="questions-box flex-c-b">
      <div class="question">字典类型为FRUITS，值为1的水果名称?</div>
      <div class="answer" v-if="answer1">{{answer1}}</div>
      <el-button type="primary" v-if="!answer1" @click="getLabelByCode">点击获取答案</el-button>
    </div>
    <div class="questions-box flex-c-b">
      <div class="question">字典类型为FRUITS，名称为草莓的水果值?</div>
      <div class="answer" v-if="answer2">{{answer2}}</div>
      <el-button type="primary" v-if="!answer2" @click="getCodeByLabel">点击获取答案</el-button>
    </div>
    <div class="questions-box flex-c-b">
      <div class="question">字典类型为FRUITS，值为1,2,3,4的水果名称分别是什么?</div>
      <div class="answer" v-if="answer3">{{answer3}}</div>
      <el-button type="primary" v-if="!answer3" @click="getLabelByCodes">点击获取答案</el-button>
    </div>
    <div class="questions-box flex-c-b">
      <div class="question">字典类型为FRUITS，名称为草莓,芒果,西瓜的水果值分别是什么?</div>
      <div class="answer" v-if="answer4">{{answer4}}</div>
      <el-button type="primary" v-if="!answer4" @click="getCodeByLabels">点击获取答案</el-button>
    </div>
    <div class="questions-box flex-c-b">
      <div class="question">想看字典类型为FRUITS的数据值?</div>
      <div class="answer" v-if="answer5.length > 0">
        <div class="flex-c-b" v-for="item in answer5" :key="item.value">
          <div class="value">{{item.value}}</div>
          <div class="label">{{item.label}}</div>
        </div>
      </div>
      <el-button type="primary" v-if="answer5.length === 0" @click="getDictObjByDictTypes1">点击查看</el-button>
    </div>

    <div class="questions-box flex-c-b">
      <div class="question">想看字典类型为SPORTS,PERSON_TYPE的数据值?</div>
      <div class="answer" v-if="answer6.PERSON_TYPE.length > 0">
        SPORTS
        <div class="flex-c-b" v-for="item in answer6.SPORTS" :key="item.value">
          <div class="value">{{item.value}}</div>
          <div class="label">{{item.label}}</div>
        </div>
        PERSON_TYPE
        <div class="flex-c-b" v-for="item in answer6.PERSON_TYPE" :key="item.value">
          <div class="value">{{item.value}}</div>
          <div class="label">{{item.label}}</div>
        </div>
      </div>
      <el-button type="primary"  v-if="answer6.PERSON_TYPE.length === 0" @click="getDictObjByDictTypes2">点击查看</el-button>
    </div>

    <el-button type="primary" @click="reset">重置</el-button>
  </div>
</template>

<script>
import {getCodeByLabel, getCodeByLabels, getLabelByCode, getLabelByCodes, getDictObjByDictTypes } from "~/index"
export default {
  name: "functions-dict",
  data() {
    return {
      answer1: "",
      answer2: "",
      answer3: "",
      answer4: "",
      answer5: [],
      answer6: {
        SPORTS: [],
        PERSON_TYPE: []
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const container = this.$refs.container
        const data = {"demoContainerHeight": container.scrollHeight + 20}
        window.parent.postMessage(data, "*")
      }, 1000)
    })
  },
  methods: {
    reset() {
      this.answer1 = this.answer2 = this.answer3 = this.answer4 = "" 
      this.answer6 = {
        SPORTS: [],
        PERSON_TYPE: []
      }
      this.answer5 = []
    },
    //通过值获取中文值
    getLabelByCode() {
      getLabelByCode("1", "FRUITS").then(data => {
        this.answer1 = data
      })
    },
    //通过中文值获取值
    getCodeByLabel() {
      getCodeByLabel("草莓", "FRUITS").then(data => {
        this.answer2 = data
      })
    },
    //通过多个值获取多个中文值
    getLabelByCodes() {
      getLabelByCodes("1,2,23131233,4", "FRUITS", "~~").then(data => {
        this.answer3 = data
      })
    },
    //通过多个中文值获取多个值
    getCodeByLabels() {
      getCodeByLabels("草莓,芒果das的萨达,西瓜", "FRUITS", "~~").then(data => {
        this.answer4 = data
      })
    },
    getDictObjByDictTypes1() {
      getDictObjByDictTypes("FRUITS").then(data => {
        this.answer5 = data["FRUITS"]
      })
    },
    getDictObjByDictTypes2() {
      getDictObjByDictTypes("SPORTS,PERSON_TYPE").then(data => {
        this.answer6 = data
      })
    }
  }
}
</script>

<style scoped>
.questions-box{
  margin-bottom: 20px;
}
</style>